import { createWebSocketStore } from 'src/components/#services/helpers';
export const sendCredential = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'auth',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'auth_socialNetworkAuth',
    },
});
